import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { UPDATE_APPLICATION_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class UpdateApplication extends BaseApiRequest {
  method = METHOD.HTTP.PUT;

  body = [];

  url = UPDATE_APPLICATION_URL;

  constructor(applicationId, payLoad) {
    super();
    this.body = payLoad;
    const paramList = [applicationId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
